// =============================================================================
// SimSense Platform — Onboarding Prompt
// =============================================================================

import { useState } from "react";
import { useAuthStore } from "../state/authStore";
import { useToast } from "./Toast";

export function OnboardingPrompt() {
  const { completeOnboarding } = useAuthStore();
  const toast = useToast();
  const [shareSetups, setShareSetups] = useState(true);
  const [shareTelemetry, setShareTelemetry] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      await completeOnboarding({
        shareSetups: shareSetups,
        shareTelemetry: shareTelemetry,
        units: "standard",
        autoDeleteIbt: false,
        retentionMonths: 6,
      });
    } catch (err) {
      toast.error("Failed to save preferences. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "rgba(0, 0, 0, 0.8)",
      backdropFilter: "blur(8px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1000,
      padding: "20px"
    }}>
      <div style={{
        background: "var(--card)",
        border: "1px solid var(--border)",
        borderRadius: "var(--radius)",
        padding: "40px",
        maxWidth: "500px",
        width: "100%",
        textAlign: "center"
      }}>
        <h2 style={{ marginBottom: "16px" }}>Welcome to SimSense!</h2>
        <p style={{ color: "var(--text2)", fontSize: "14px", marginBottom: "32px", lineHeight: 1.6 }}>
          To build our Community Benchmarks and provide accurate pace analysis, we always collect anonymized telemetry. You can choose whether to share your telemetry and setups publicly below.
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: "20px", textAlign: "left", marginBottom: "40px" }}>
          <label style={{ display: "flex", alignItems: "center", gap: "12px", cursor: "pointer" }}>
            <input
              type="checkbox"
              checked={shareTelemetry}
              onChange={(e) => setShareTelemetry(e.target.checked)}
              style={{ width: "18px", height: "18px" }}
            />
            <div>
              <div style={{ fontSize: "14px", fontWeight: 600 }}>Public Telemetry Sharing</div>
              <div style={{ fontSize: "12px", color: "var(--text2)" }}>Allow other drivers to view your lap data and comparisons.</div>
            </div>
          </label>

          <label style={{ display: "flex", alignItems: "center", gap: "12px", cursor: "pointer" }}>
            <input
              type="checkbox"
              checked={shareSetups}
              onChange={(e) => setShareSetups(e.target.checked)}
              style={{ width: "18px", height: "18px" }}
            />
            <div>
              <div style={{ fontSize: "14px", fontWeight: 600 }}>Public Setup Sharing</div>
              <div style={{ fontSize: "12px", color: "var(--text2)" }}>Make your setups discoverable by other SimSense users.</div>
            </div>
          </label>
        </div>

        <button 
          onClick={handleSubmit}
          disabled={isSubmitting}
          style={{
            width: "100%",
            padding: "12px",
            background: "var(--accent)",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            fontWeight: 600,
            cursor: "pointer",
            transition: "opacity 0.2s"
          }}
        >
          {isSubmitting ? "Saving..." : "Start Analyzing →"}
        </button>
      </div>
    </div>
  );
}
